import { DynamicFormBaseField, DynamicFormSection } from 'app/interfaces/dynamic-form-field.interface';
import { DynamicFormValueData } from 'components/multiple-dynamic-form/multiple-dynamic-form.interface';
import { OnboardingStepAdditionalData } from 'components/modal-windows/step-details/onboarding-details/onboarding-details.constant';
import { OnboardingPSVStepAdditionalData } from 'features/workflow-module/components/onboarding-psv-step-form/onboarding-psv-step-form.constants';

export interface CurrentPhaseOptions {
  fail: { id: number; name: string; typeId?: number }[];
  success: { id: number; name: string; typeId?: number }[];
}

/* Testing Provider */
export interface TestingProvider {
  name: string;
  id: number;
}

export interface TestingProviderExam {
  id: number;
  name: string;
}

export interface TestingProviderInfo {
  id?: number;
  exams: TestingProviderExam[];
  practiceTestUrl: string;
  registrationUrl: string;
  feeUrl: string;
  schedulingUrl: string;
  testTakingUrl: string;
  testRegistrationFormFields: {
    elements: DynamicFormBaseField[];
    sections: DynamicFormSection[];
  };
  adaFields: {
    elements: DynamicFormBaseField[];
    sections: DynamicFormSection[];
  };
}

export interface WorkflowListItem {
  id: number;
  name: string;
  version: number;
  validFrom: Date;
  validTo: Date;
  updateDate: Date;
  selected?: boolean;
  isEditable: boolean;
}

export interface WorkflowListResponse {
  rows: WorkflowListItem[];
  count: number;
}

export interface WorkflowStepCompletePayload {
  stepInstanceId: number;
  stepTypeId: number;
  specificStepTypePayload: DynamicFormValueData;
  signature?: string;
}

export enum WORKFLOW_ACTION_TYPE {
  INIT,
  SAVE_WORKFLOW,
  COMPLETE,
  FINISH,
}

export type CertificationStepAdditionalData = OnboardingStepAdditionalData | OnboardingPSVStepAdditionalData | any;
